import Reveal from '@/components/base/Reveal';
import VendorForm from './VendorForm';
import { vendorRequirements } from '@/mocks/site';

export default function Vendor() {
  return (
    <section id="vendor" className="bg-foreground-950 px-5 py-16 pr-14 md:px-10 md:py-24 md:pr-20">
      <div className="mx-auto max-w-6xl">
        <div className="grid gap-10 md:grid-cols-12 md:gap-14">
          <div className="md:col-span-5">
            <Reveal variant="up">
              <div className="flex items-center gap-3">
                <span className="h-px w-8 bg-primary-500" />
                <p className="text-[10px] en-label text-primary-400">FOR VENDORS</p>
              </div>
              <h2 className="mt-5 font-heading text-[27px] font-black leading-[1.3] text-background-50 md:text-[38px]">
                出店者募集
              </h2>
              <p className="mt-5 text-[13px] leading-[2] text-background-50/70 md:text-[14px]">
                キッチンカー、屋台、ハンドメイドの小さなお店まで。自慢の一杯、ひと皿、ひとつの作品を会場に並べてみませんか。初めての出店でも、運営が当日まで伴走します。
              </p>
            </Reveal>

            <Reveal variant="up" delay={120} className="mt-8">
              <dl className="divide-y divide-background-50/12 border-y border-background-50/12">
                {vendorRequirements.map((row) => (
                  <div key={row.label} className="flex flex-col gap-1.5 py-3.5 sm:flex-row sm:gap-6">
                    <dt className="w-28 shrink-0 text-[11.5px] font-bold text-background-50/50">{row.label}</dt>
                    <dd className="text-[12.5px] leading-relaxed text-background-50/85">{row.value}</dd>
                  </div>
                ))}
              </dl>
            </Reveal>

            <Reveal variant="fade" delay={220} className="mt-6 rounded-md border border-background-50/15 bg-background-50/[0.04] p-4">
              <p className="text-[11px] leading-[1.85] text-background-50/65">
                <i className="ri-information-line mr-1 text-accent-300" aria-hidden="true" />
                出店料・ブースサイズなどの詳細は現在調整中です。お申し込み後に、個別にご案内いたします。
              </p>
            </Reveal>

            <Reveal variant="fade" delay={280} className="mt-6 flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-full border border-background-50/20 text-background-50/70">
                <i className="ri-whatsapp-line text-sm" aria-hidden="true" />
              </span>
              <p className="text-[11.5px] leading-relaxed text-background-50/55">
                ご相談は公式LINE・SNSのDMが最速です。
                <br />
                フォームからのお問い合わせも受け付けています。
              </p>
            </Reveal>
          </div>

          <div className="md:col-span-7">
            <Reveal variant="up" delay={100}>
              <VendorForm />
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}